import React from 'react'
import { Switch, Route } from 'react-router-dom'
import { Grid, Row, Col } from 'react-flexbox-grid'

import Header from './Header'
import ReportsMonthlyGoalEntryView from '../../views/ReportsMonthlyGoalDataEntry'

import './styles.scss'

export default class ReportsMonthlyGoalDataEnrtyLayout extends React.PureComponent {
  render() {
    return (
      <Grid>
        <Row>
          <Col xs={12}>
            <Header />
          </Col>
        </Row>
        <Switch>
          <Route component={ReportsMonthlyGoalEntryView} />
        </Switch>
      </Grid>
    )
  }
}
